export default __webpack_public_path__ + "static/media/yummiyogurt.706fe89a.png";